<template>
  <v-card
    color="indigo"
    dark>
    <v-card-title>{{ evento.descripcion || evento.detail}}</v-card-title>
    <v-card-text>
      <audio :src="evento.audio" v-if="evento.audio" controls>
        <p>Tu navegador no implementa el elemento audio.</p>
      </audio>
      <img :src="`data:image/png;base64,${evento.photo}`" style="max-width:450px;" v-if="evento.photo">
      <span class="title" v-if="evento.text">{{ evento.text }}</span>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props:{
    evento: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style>

</style>